// @core/api/endpoints/document/delete_block.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete block
 * Permanently deletes a block and all its nested children. Updates the document's block_count and updated_at.
 */
export async function DeleteBlock(
  document_id: string,
  block_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id/blocks/:block_id`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  requestPath = requestPath.replace(':block_id', encodeURIComponent(block_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
